import { API } from "../api";

export const investorKycApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getInvestorKyc: builder.query({
      query: () => ({
        url: "/investors/kyc",
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "InvestorKyc", id: "CURRENT" }],
    }),
    submitInvestorKyc: builder.mutation({
      query: (body) => ({
        url: "/investors/kyc",
        method: "POST",
        body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "InvestorKyc", id: "CURRENT" },
        { type: "InvestorProfile", id: "CURRENT" },
      ],
    }),
    resubmitInvestorKyc: builder.mutation({
      query: (body) => ({
        url: "/investors/kyc/resubmit",
        method: "POST",
        body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "InvestorKyc", id: "CURRENT" },
        { type: "InvestorProfile", id: "CURRENT" },
      ],
    }),
  }),
});

export const {
  useGetInvestorKycQuery,
  useSubmitInvestorKycMutation,
  useResubmitInvestorKycMutation,
} = investorKycApi;
